// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"ef694213","216":"01ef0c2d","238":"60571314","455":"14cb9fbe","468":"1124dc47","696":"4bcc5d64","977":"1fa8c7fd"}[chunkId] + ".chunk.js";
};